import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './estilo.css'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não encontrado em index.html')

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Registra o service worker — é ele que faz o app abrir sem sinal e ganhar
// ícone na tela do celular. Falha aqui não pode derrubar o app: sem sinal o
// tratador ainda precisa da tela.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((erro) => {
      console.warn('service worker não registrado:', erro)
    })
  })
}
